<template lang="pug">
  .subscription
    v-container.white.px-6(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/clinic/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('subscription') }}

      v-layout.my-6(v-if="!$store.state.subscriptions.isReady")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        div.my-6
          .s1 {{ $t('my_plans') }}
          .c1.basic600--text
            | {{ $t('products_plans_subscribed') }}
            //- span.textColorAccent--text(@click="sendRequest")  Click here
            //- |  to change your company subscription.

          .empty.mt-4(v-if="noSubscription")

            div.mx-auto.text-center
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption.text-center {{ $t('no_subscription_found') }}
          
          template(v-else)

            .yezza
              v-card.mt-4(v-if="yezzaTrial.value || yezzaSubscription.value" outlined flat)
                .content.pa-4
                  .trial(v-if="yezzaTrial.value")
                    .p2 Yezza
                    .s2.text-uppercase {{ getContractDisplayName(yezzaTrial.data.contract.code) }}
                    .c1.primary400--text
                      span(v-if="yezzaTrial.data.expired") {{ $t('trial_ended_at') }} {{ yezzaTrial.data.end_date | humanizeDate }}
                      span(v-else) {{ $t('trial_ends') }}: {{ yezzaTrial.data.end_date | humanizeDate }}

                  .subscribed(v-else-if="yezzaSubscription.value")
                    .p2 Yezza
                    div.d-flex
                      .s2.text-uppercase {{ getContractDisplayName(yezzaSubscription.data.contract.code) }}
                      v-spacer
                      .s2 {{ yezzaSubscription.data.next_bill_amount | displayPrice($currency) }}
                        span {{ yezzaSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ yezzaSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1(v-if="yezzaSubscription.data.contract.code.includes('_YY') || yezzaSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ yezzaSubscription.data.contract_end_date | humanizeDate }}
                
                v-divider.basic400
                .content.pa-4
                  .sales-team
                    v-layout
                      div.label.basic600--text.text-uppercase {{ $t('sales_team') }}
                      v-spacer
                      div.ml-2.my-auto.c1.basic600--text(v-if="yezzaSubscription.limitations.member >= 0") {{ company.active_member_count }} of {{ yezzaSubscription.limitations.member }}
                      div.ml-2.my-auto.c1.basic600--text(v-else) {{ $t('unlimited') }}
                    v-layout.mt-4
                      v-progress-linear(v-if="yezzaSubscription.limitations.member >= 0" color="success400" background-color = "basic300" height=6 rounded :value="salesTeamProgress(yezzaSubscription.limitations.member)")
                      v-progress-linear(v-else color="success400" background-color = "basic300" height=6 rounded value=0)
                  .forms.mt-6
                    v-layout
                      div.label.basic600--text.text-uppercase {{ $t('whatsapp_forms') }}
                      v-spacer
                      div.ml-2.my-auto.c1.basic600--text(v-if="yezzaSubscription.limitations.form >= 0") {{ company.published_form_count }} of {{ yezzaSubscription.limitations.form }}
                      div.ml-2.my-auto.c1.basic600--text(v-else) {{ $t('unlimited') }}

                    v-layout.mt-4
                      v-progress-linear(v-if="yezzaSubscription.limitations.form >= 0" color="success400" background-color = "basic300" height=6 rounded :value="formsProgress(yezzaSubscription.limitations.form)")
                      v-progress-linear(v-else color="success400" background-color = "basic300" height=6 rounded value=0)

                  .woocommerce.mt-6
                    v-layout
                      div.label.basic600--text.text-uppercase WooCommerce
                      v-spacer
                      div.ml-2
                        v-icon(v-if="Auth('root', 'e_commerce_integrations')" small color="green") mdi-check-circle
                        v-icon(v-else small color="error") mdi-close-circle
                    v-layout.mt-4
                      v-progress-linear(color="success400" background-color = "basic300" height=6 rounded :value="woocommerceProgress")
                  .shopify.mt-5
                    v-layout
                      div.label.basic600--text.text-uppercase Shopify
                      v-spacer
                      div.ml-2
                        v-icon(v-if="Auth('root', 'e_commerce_integrations')" small color="green") mdi-check-circle
                        v-icon(v-else small color="error") mdi-close-circle
                    v-layout.mt-4
                      v-progress-linear(color="success400" background-color = "basic300" height=6 rounded :value="shopifyProgress")

                  div.d-flex.mt-4
                    v-spacer
                    v-btn.button-AA-tiny.white--text(v-if="yezzaTrial.value" color="info500" small depressed @click="showSubscribeModal = true") {{ $t('subscribe_now') }}
                    v-btn.button-Aa-small.info500--text.px-0(v-else-if="yezzaSubscription.value" text color="transparent" small depressed :loading="isLoadingExpired" @click="yezzaExpired ? checkExpired('yezza') : showEditSubscriptionModal = true") {{ yezzaExpired ? $t('renew_subscription') : $t('edit_subscription') }}

            .ybooks(v-if="company.currency.currency_code === 'MYR'")
              v-card.mt-4(v-if="yBooksTrial.value || yBooksSubscription.value" outlined flat)
                .content.pa-4
                  .trial(v-if="yBooksTrial.value")
                    .p2 {{ $t('books') }}
                    div.d-flex
                      .s2.text-uppercase {{ $t('trial') }}
                    .c1.primary400--text
                      span(v-if="yBooksTrial.data.expired") {{ $t('trial_ended_at') }} {{ yBooksTrial.data.end_date | humanizeDate }}
                      span(v-else) {{ $t('trial_ends') }}: {{ yBooksTrial.data.end_date | humanizeDate }}

                  .subscribed(v-else-if="yBooksSubscription.value")
                    .p2 {{ $t('books') }}
                    div.d-flex
                      .s2.text-uppercase {{ getContractDisplayName(yBooksSubscription.data.contract.code) }}
                      v-spacer
                      .s2 {{ yBooksSubscription.data.next_bill_amount | displayPrice($currency) }}
                        span {{ yBooksSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ yBooksSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1(v-if="yBooksSubscription.data.contract.code.includes('_YY') || yBooksSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ yBooksSubscription.data.contract_end_date | humanizeDate }}

                v-divider.basic400
                .content.pa-4
                  .reminder
                    v-layout
                      div.label.basic600--text.text-uppercase {{ $t('reminder_scheduling') }}
                      v-spacer
                      div.ml-2
                        v-icon(v-if="yBooksSubscription.limitations.reminder <= 0" small color="error") mdi-close-circle
                        v-icon(v-else small color="green") mdi-check-circle
                    v-layout.mt-4
                      v-progress-linear(color="success400" background-color = "basic300" height=6 rounded :value="0")

                  div.d-flex.mt-4
                    v-spacer
                    v-btn.button-AA-tiny.white--text(v-if="yBooksTrial.value" color="info500" small depressed @click="showSubscribeBookModal = true") {{ $t('subscribe_now') }}
                    v-btn.button-Aa-small.info500--text.px-0(v-else-if="yBooksSubscription.value" text color="transparent" small depressed :loading="isLoadingExpired" @click="booksExpired ? checkExpired('books') : showEditSubscriptionBookModal = true") {{ booksExpired ?  $t('renew_subscription') : $t('edit_subscription') }}
            
            .landingpage
              v-card.mt-4(v-if="landingPageTrial.value || landingPageSubscription.value" outlined flat)
                .content.pa-4
                  .trial(v-if="landingPageTrial.value")
                    .p2 {{ $t('sales_page') }}
                    div.d-flex
                      .s2.text-uppercase {{ $t('trial') }}
                    .c1.primary400--text
                      span(v-if="landingPageTrial.data.expired") {{ $t('trial_ended_at') }} {{ landingPageTrial.data.end_date | humanizeDate }}
                      span(v-else) {{ $t('trial_ends') }}: {{ landingPageTrial.data.end_date | humanizeDate }}

                  .subscribed(v-else-if="landingPageSubscription.value")
                    .p2 {{ $t('sales_pages') }}
                    div.d-flex
                      .s2.text-uppercase {{ getContractDisplayName(landingPageSubscription.data.contract.code) }}
                      v-spacer
                      .s2 {{ landingPageSubscription.data.next_bill_amount | displayPrice($currency) }}
                        span {{ landingPageSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ landingPageSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1(v-if="landingPageSubscription.data.contract.code.includes('_YY') || landingPageSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ landingPageSubscription.data.contract_end_date | humanizeDate }}

                  div.d-flex.mt-4
                    v-spacer
                    v-btn.button-AA-tiny.white--text(v-if="landingPageTrial.value || (landingPageSubscription.value && landingPageSubscription.data.expired)" color="info500" small depressed @click="showSubscribeLandingPageModal = true") {{ landingPageTrial.value ? $t('subscribe_now') : $t('renew_subscription') }}
                    v-btn.button-Aa-small.info500--text.px-0(v-else-if="landingPageSubscription.value && !landingPageSubscription.data.expired" text color="transparent" small depressed @click="unsubscribeCurrentPlan(landingPageSubscription)") {{ $t('unsubscribe') }}

            .followup
              v-card.mt-4(v-if="followUpSubscription.value" outlined flat)
                .content.pa-4
                  .p2 {{ $t('follow_up') }}
                  div.d-flex
                    .s2.text-uppercase {{ $t('monthly') }}
                    v-spacer
                    .s2 {{ followUpSubscription.data.next_bill_amount | displayPrice($currency) }}
                      span {{ followUpSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                  .c1.mt-1 {{ $t('next_billing_date') }}: {{ followUpSubscription.data.end_date | humanizeDate }}
                  .c1.primary400--text.mt-1(v-if="followUpSubscription.data.contract.code.includes('_YY') || followUpSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ followUpSubscription.data.contract_end_date | humanizeDate }}

                  div.d-flex.mt-4
                    v-spacer
                    v-btn.button-Aa-small.info500--text.px-0(text color="transparent" small depressed @click="unsubscribeCurrentPlan(followUpSubscription)") {{ $t('unsubscribe') }}

            .bundle
              v-card.mt-4(v-if="bundleSubscription.value" outlined flat)
                .content.pa-4
                  .p2 {{ $t('bundle_offer') }}
                  div.d-flex
                    .s2.text-uppercase {{ $t('monthly') }}
                    v-spacer
                    .s2 {{ bundleSubscription.data.next_bill_amount | displayPrice($currency) }}
                      span {{ bundleSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                  .c1.mt-1 {{ $t('next_billing_date') }}: {{ bundleSubscription.data.end_date | humanizeDate }}
                  .c1.primary400--text.mt-1(v-if="bundleSubscription.data.contract.code.includes('_YY') || bundleSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ bundleSubscription.data.contract_end_date | humanizeDate }}

                  div.d-flex.mt-4
                    v-spacer
                    v-btn.button-Aa-small.info500--text.px-0(text color="transparent" small depressed @click="unsubscribeCurrentPlan(bundleSubscription)") {{ $t('unsubscribe') }}

            .reseller
              v-card.mt-4(v-if="resellerSubscription.value" outlined flat)
                .content.pa-4
                  .p2 {{ $t('agent_commission') }}
                  div.d-flex
                    .s2.text-uppercase {{ $t('monthly') }}
                    v-spacer
                    .s2 {{ resellerSubscription.data.next_bill_amount | displayPrice($currency) }}
                      span {{ resellerSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                  .c1.mt-1 {{ $t('next_billing_date') }}: {{ resellerSubscription.data.end_date | humanizeDate }}
                  .c1.primary400--text.mt-1(v-if="resellerSubscription.data.contract.code.includes('_YY') || resellerSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ resellerSubscription.data.contract_end_date | humanizeDate }}

                  div.d-flex.mt-4
                    v-spacer
                    v-btn.button-Aa-small.info500--text.px-0(text color="transparent" small depressed @click="unsubscribeCurrentPlan(resellerSubscription)") {{ $t('unsubscribe') }}

            .connect
              v-card.mt-4(v-if="connectSubscription.value" outlined flat)
                .content.pa-4
                  .p2 Connect
                  div.d-flex
                    .s2.text-uppercase {{ getContractDisplayName(connectSubscription.data.contract.code) }}
                    v-spacer
                    .s2 {{ connectSubscription.data.next_bill_amount | displayPrice($currency) }}
                      span {{ connectSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                  div(v-if="connectSubscription.data.contract_end_date")
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ connectSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1 {{ $t('contract_ends') }}: {{ connectSubscription.data.contract_end_date | humanizeDate }}
                  .d-flex.mt-4
                    v-spacer
                    v-btn.button-Aa-small.info500--text.px-0(v-if="connectSubscription.value" text color="transparent" small depressed @click="showEditSubscriptionConnectModal = true") {{ $t('edit_subscription') }}

            .clinic
              v-card.mt-4(v-if="clinicTrial.value || clinicSubscription.value" outlined flat)
                .content.pa-4
                  .trial(v-if="clinicTrial.value")
                    .p2 {{ $t('clinic') }}
                    div.d-flex
                      .s2.text-uppercase {{ $t('trial') }}
                    .c1.primary400--text
                      span(v-if="clinicTrial.data.expired") {{ $t('trial_ended_at') }} {{ clinicTrial.data.end_date | humanizeDate }}
                      span(v-else) {{ $t('trial_ends') }}: {{ clinicTrial.data.end_date | humanizeDate }}

                  .subscribed(v-else-if="clinicSubscription.value")
                    .p2 {{ $t('clinic') }}
                    div.d-flex
                      .s2.text-uppercase {{ getContractDisplayName(clinicSubscription.data.contract.code) }}
                      v-spacer
                      .s2 {{ clinicSubscription.data.next_bill_amount | displayPrice($currency) }}
                        span {{ clinicSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ clinicSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1(v-if="clinicSubscription.data.contract.code.includes('_YY') || clinicSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ clinicSubscription.data.contract_end_date | humanizeDate }}
                  
                  .d-flex.mt-4
                    v-spacer
                    v-btn.button-AA-tiny.white--text(v-if="clinicTrial.value" color="info500" small depressed @click="showSubscribeClinicModal = true") {{ $t('subscribe_now') }}
                    v-btn.button-Aa-small.info500--text.px-0(v-else-if="clinicSubscription.value" text color="transparent" small depressed :loading="isLoadingExpired" @click="clinicExpired ? checkExpired('clinic') : showEditSubscriptionClinicModal = true") {{ clinicExpired ?  $t('renew_subscription') : $t('edit_subscription') }}

            .review
              v-card.mt-4(v-if="reviewSubscription.value" outlined flat)
                .content.pa-4
                  .subscribed
                    .p2 {{ $t('review') }}
                    div.d-flex
                      .s2.text-uppercase {{ getContractDisplayName(reviewSubscription.data.contract.code) }}
                      v-spacer
                      .s2 {{ reviewSubscription.data.next_bill_amount | displayPrice($currency) }}
                        span {{ reviewSubscription.data.contract.code.includes('_YY') ? '/year' : '/month' }}
                    .c1.mt-1 {{ $t('next_billing_date') }}: {{ reviewSubscription.data.end_date | humanizeDate }}
                    .c1.primary400--text.mt-1(v-if="reviewSubscription.data.contract.code.includes('_YY') || reviewSubscription.data.contract.code.includes('_YM')") {{ $t('contract_ends') }}: {{ reviewSubscription.data.contract_end_date | humanizeDate }}
                  
                  .d-flex.mt-4
                    v-spacer
                    v-btn.button-Aa-small.info500--text.px-0(text color="transparent" small depressed :loading="isLoadingExpired" @click="reviewExpired ? checkExpired('review') : showEditSubscriptionReviewModal = true") {{ reviewExpired ?  $t('renew_subscription') : $t('edit_subscription') }}
        

      v-divider.basic400
      div.my-6
        .s1 {{ $t('more_products') }}
        .c1.basic600--text
          | {{ $t('more_products_desc') }}
        v-card.mt-4(outlined flat)
          .content.pa-4
            div.d-flex.align-center
              div
                span.s1 {{ $t('review') }}&nbsp;
                span.f2(v-if="prices.review") ({{ $t('yezza_price_per_month', { price: $options.filters.displayPrice(prices.review) }) }})
                .c1.primary400--text {{ $t('review_subscription_description') }}
              v-spacer
              v-btn.px-2(v-if="reviewSubscription.value" small depressed :style="{'background-color': $vuetify.theme.themes[$theme].textColorDisabled}")
                .button-AA-tiny.basic100--text {{ $t('subscribed') }}
              v-btn.px-2(v-else small depressed dark color="info500" @click="showSubscribeReviewModal = true")
                .button-AA-tiny.basic100--text
                  span.text-uppercase {{ $t('tell_me_more') }}

    .modals
      yezza-intro-modal(:open.sync="showYezzaIntroModal" :company="company" @try="startTrial('YZ_START_PLAN_TRIAL')")
      books-intro-modal(:open.sync="showBooksIntroModal" :company="company" @try="startTrial('YBOOKS_NORMAL_TRIAL')")
      subscribe-modal(v-if="showSubscribeModal" :open.sync="showSubscribeModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
      subscribe-book-modal(v-if="showSubscribeBookModal" :open.sync="showSubscribeBookModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
      type-form-view(v-if="openTypeFormDialog" :open.sync="openTypeFormDialog" :link="typeFormSubscriptionUrl")
      edit-subscription-modal(v-if="showEditSubscriptionModal" :open.sync="showEditSubscriptionModal" :company="company" @subscribed="$store.commit('subscriptions/update')" @setgene="setGene")
      edit-subscription-book-modal(v-if="showEditSubscriptionBookModal" :open.sync="showEditSubscriptionBookModal" :company="company" @subscribed="$store.commit('subscriptions/update')" @setgene="setGene")
      sales-page-subscription(v-if="showSubscribeLandingPageModal" :open.sync="showSubscribeLandingPageModal" :company="company")
      follow-up-subscription(v-if="openFollowUpSubscription" :open.sync="openFollowUpSubscription" :company="company" :upgrade="false")
      bundle-subscription(v-if="openBundleSubscription" :open.sync="openBundleSubscription" :company="company" :upgrade="false")
      reseller-subscription(v-if="openResellerSubscriptionDialog" :open.sync="openResellerSubscriptionDialog" :upgrade="false")
      edit-subscription-connect-modal(v-if="showEditSubscriptionConnectModal" :open.sync="showEditSubscriptionConnectModal" :company="company")
      edit-subscription-clinic-modal(v-if="showEditSubscriptionClinicModal" :open.sync="showEditSubscriptionClinicModal" :company="company" @subscribed="$store.commit('subscriptions/update')" @setgene="setGene")
      edit-subscription-review-modal(v-if="showEditSubscriptionReviewModal" :open.sync="showEditSubscriptionReviewModal" :company="company" @subscribed="$store.commit('subscriptions/update')" @setgene="setGene")
      subscribe-clinic-modal(v-if="showSubscribeClinicModal" :open.sync="showSubscribeClinicModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")
      subscribe-review-modal(v-if="showSubscribeReviewModal" :open.sync="showSubscribeReviewModal" :company="company" :volunteer="true" @subscribed="$store.commit('subscriptions/update')")

      y-dialog(v-if="unsubscribeModal" v-model='unsubscribeModal', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('unsubscribe') }} {{ unsubscribePlan.title }}
          v-card-text.p2.primary500--text.px-4 {{ $t('unsubscribe_confirmation') }} {{ unsubscribePlan.title }}?
          v-card-actions
            v-spacer
            v-btn(color='white', text @click="unsubscribeModal = false; unsubscribePlan = null")
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='info500' depressed height=32 @click="startUnsubscribe" dark :loading="isLoading")
              .button-AA-small.basic100--text {{ $t('confirm') }}

      y-dialog(v-if="openSuccessDialog" v-model='openSuccessDialog', max-width='270')
        v-card.pa-4.text-center
          div.p1.primary500--text {{ message }}
          v-btn.mt-3(color='transparent', text @click='closeDialog' block x-small)
            .button-Aa-small.primary400--text Close

</template>

<script>
import { mapActions, mapState } from 'vuex'
import { DateTime } from 'luxon'
import YezzaIntroModal from '@/components/billing/YezzaIntroModal.vue'
import BooksIntroModal from '@/components/billing/BooksIntroModal.vue'
import SubscribeModal from '@/components/billing/SubscribeModal.vue'
import EditSubscriptionModal from '@/components/billing/EditSubscriptionModal.vue'
import EditSubscriptionBookModal from '@/components/billing/EditSubscriptionBookModal.vue'
import SalesPageSubscription from '@/components/dialogs/landingform/SalesPageSubscription'
import SubscribeBookModal from '@/components/billing/SubscribeBookModal.vue'
import TypeFormView from '@/components/dialogs/TypeFormView.vue'
import FollowUpSubscription from '@/components/dialogs/followup/FollowUpSubscription.vue'
import BundleSubscription from '@/components/offers/dialogs/bundles/BundleSubscription.vue'
import ResellerSubscription from '@/components/resellers/dialogs/ResellerSubscription.vue'
import EditSubscriptionConnectModal from '@/components/connect/dialogs/EditSubscriptionConnectModal.vue'
import EditSubscriptionClinicModal from '@/components/clinic/dialogs/EditSubscriptionClinicModal.vue'
import EditSubscriptionReviewModal from '@/components/clinic/dialogs/EditSubscriptionReviewModal.vue'
import SubscribeClinicModal from '@/components/clinic/dialogs/SubscribeClinicModal.vue'
import SubscribeReviewModal from '@/components/clinic/dialogs/SubscribeReviewModal.vue'

export default {
  name: 'ClinicSubscriptionSettings',
  components: { YezzaIntroModal, BooksIntroModal, SubscribeModal, EditSubscriptionModal, EditSubscriptionBookModal, SalesPageSubscription, SubscribeBookModal,TypeFormView, FollowUpSubscription, BundleSubscription, ResellerSubscription, EditSubscriptionConnectModal, EditSubscriptionClinicModal, SubscribeClinicModal, EditSubscriptionReviewModal, SubscribeReviewModal },
  props: ['company', 'menu'],
  data: () =>  ({
    showYezzaIntroModal: false,
    showBooksIntroModal: false,
    showSubscribeModal: false,
    showEditSubscriptionModal: false,
    showEditSubscriptionBookModal: false,
    showEditSubscriptionConnectModal: false,
    showEditSubscriptionClinicModal: false,
    showEditSubscriptionReviewModal:false,
    showSubscribeLandingPageModal: false,
    showSubscribeBookModal: false,
    showSubscribeClinicModal: false,
    showSubscribeReviewModal: false,
    openFollowUpSubscription: false,
    openBundleSubscription: false,
    openResellerSubscriptionDialog: false,
    openTypeFormDialog: false,
    openSuccessDialog: false,
    unsubscribeModal: false,
    unsubscribePlan: null,
    isLoadingExpired: false,
    message:  null,
    contract: null,
    addons: null,
    isLoading: false,
    prices: {}
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', [
      'noSubscription',
      'yezzaTrial',
      'yezzaSubscription',
      'landingPageTrial',
      'landingPageSubscription',
      'yBooksTrial',
      'yBooksSubscription',
      'followUpSubscription',
      'bundleSubscription',
      'resellerSubscription',
      'connectSubscription',
      'clinicTrial',
      'clinicSubscription',
      'reviewSubscription',
    ]),
    woocommerceProgress () {
      if (this.menu.woocommerce_enabled) {
        return 100
      }
      return 0
    },
    shopifyProgress () {
      if (this.menu.shopify_enabled) {
        return 100
      }
      return 0
    },
    typeFormSubscriptionUrl () {
      let plan = ''
      if (this.yezzaSubscription.value) {
        plan = plan + this.yezzaSubscription.data.contract.code
      }
      if (this.yBooksSubscription.value) {
        if (plan.length > 0) {
          plan = plan + '+'
        }
        plan = plan + this.yBooksSubscription.data.contract.code
      }
      return `https://yezzaio.typeform.com/to/OxSBx4Ui#id=${this.company.id}&s=${this.company.slug}&op=${plan}`
    },
    yezzaExpired () {
      if (this.yezzaSubscription.value && this.yezzaSubscription.data.expired) {
        return true
      }
      return false
    },
    booksExpired () {
      if (this.yBooksSubscription.value && this.yBooksSubscription.data.expired) {
        return true
      }
      return false
    },
    clinicExpired () {
      if (this.clinicSubscription.value && this.clinicSubscription.data.expired) {
        return true
      }
      return false
    },
    reviewExpired () {
      if (this.reviewSubscription.value && this.reviewSubscription.data.expired) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.$route.query.upgrade) {
      this.showEditSubscriptionModal = true
    }
    this.fetchPlanPrices()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchPlanPrices () {
      this.$axios.get(`/subscription/plans`)
        .then(resp => {
          const results = resp.data.results
          const start = results.find(f => f.contracts.find(i => i.code === 'YZ_START_PLAN_MM'))
          if (start) { this.$set(this.prices, 'start', start.contracts.find(i => i.code === 'YZ_START_PLAN_MM').prices) }
          const books = results.find(f => f.contracts.find(i => i.code === 'YBOOKS_NORMAL_MM'))
          if (books) { this.$set(this.prices, 'books', books.contracts.find(i => i.code === 'YBOOKS_NORMAL_MM').prices) }
          const landing = results.find(f => f.contracts.find(i => i.code === 'YZ_LANDING_PAGE_PLAN_MM'))
          if (landing) { this.$set(this.prices, 'landing', landing.contracts.find(i => i.code === 'YZ_LANDING_PAGE_PLAN_MM').prices) }
          const reseller = results.find(f => f.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM'))
          if (reseller) { this.$set(this.prices, 'reseller', reseller.contracts.find(i => i.code === 'YZ_RESELLER_PLAN_MM').prices) }
          const bundle = results.find(f => f.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM'))
          if (bundle) { this.$set(this.prices, 'bundle', bundle.contracts.find(i => i.code === 'YZ_PRODUCT_BUNDLE_PLAN_MM').prices) }
          const followup = results.find(f => f.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM'))
          if (followup) { this.$set(this.prices, 'followup', followup.contracts.find(i => i.code === 'YZ_FOLLOW_UP_PLAN_MM').prices) }
          const connect = results.find(f => f.contracts.find(i => i.code === 'YC_BASIC_PLAN_MM'))
          if (connect) { this.$set(this.prices, 'connect', connect.contracts.find(i => i.code === 'YC_BASIC_PLAN_MM').price) }
          const clinic = results.find(f => f.contracts.find(i => i.code === 'YZ_CLINIC_PLAN_MM'))
          if (clinic) { this.$set(this.prices, 'clinic', clinic.contracts.find(i => i.code === 'YZ_CLINIC_PLAN_MM').price) }
          const review = results.find(f => f.contracts.find(i => i.code === 'YZ_REVIEW_PLAN_MM'))
          if (review) { this.$set(this.prices, 'review', review.contracts.find(i => i.code === 'YZ_REVIEW_PLAN_MM').price) }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    nextBillingCycleDate () {
      let local = DateTime.local()
      return local.plus({ months: 1 })
    },
    getContractDisplayName (contract) {
      let display = ''
      // BOOKS
      if (contract === 'YBOOKS_NORMAL_MM') {
        display = 'Monthly'
      } else if (contract === 'YBOOKS_NORMAL_YY') {
        display = 'Yearly'
      }
      // YEZZA
      if (contract.includes('YZ_FREE_PLAN')) {
        display = 'FREE PLAN'
      } else if (contract.includes('YZ_FREE_V2_PLAN')) {
        display = 'FREE PLAN'
      } else if (contract.includes('YZ_PERSONAL')) {
        display = 'PERSONAL'
      } else if (contract.includes('YZ_BIZ')) {
        display = 'BUSSINESS'
      } else if (contract.includes('YZ_INTEL')) {
        display = 'INTELLIGENCE'
      } else if (contract.includes('YZ_START')) {
        display = 'START'
      } else if (contract.includes('YZ_GROWTH')) {
        display = 'GROWTH'
      }
      if (contract.includes('YZ_')) {
        if (contract.includes('_Y')) {
          display += ' (YEARLY)'
        } else if (contract.includes('_M')) {
          display += ' (MONTHLY)'
        }
      }
      if (contract.includes('_TRIAL')) {
        display += ' (TRIAL)'
      }
      // SALESPAGE
      if (contract === 'YZ_LANDING_PAGE_PLAN_MM') {
        display = 'SALES PAGE (MONTHLY)'
      }
      else if (contract === 'YZ_LANDING_PAGE_PLAN_TRIAL') {
        display = 'SALES PAGE (TRIAL)'
      }
      // CONNECT
      if (contract === 'YC_FREE_PLAN') {
        display = 'FREE'
      } else if (contract === 'YC_BASIC_PLAN_MM') {
        display = 'BASIC (MONTHLY)'
      }
      // CLINIC
      if (contract === 'YZ_CLINIC_PLAN_MM') {
        display = 'Monthly'
      } else if (contract === 'YZ_CLINIC_PLAN_YY') {
        display = 'Yearly'
      }
      // REVIEW
      if (contract === 'YZ_REVIEW_PLAN_MM') {
        display = 'Monthly'
      } else if (contract === 'YZ_REVIEW_PLAN_YY') {
        display = 'Yearly'
      }
      return display
    },
    salesTeamProgress (max) {
      return Math.floor((this.company.active_member_count.toFixed(2) / max.toFixed(2)) * 100)
    },
    formsProgress (max) {
      return Math.floor((this.company.published_form_count.toFixed(2) / max.toFixed(2)) * 100)
    },
    startTrial (contract) {
      this.trackPixel(this.company.id)
      this.isLoading = true
      const subscription = {
        company: this.company.id,
        contract: contract
      }
      if (subscription.contract === 'YBOOKS_NORMAL_TRIAL') {
        subscription.add_ons = [{ feature: 'YBOOKS_REMINDER', count: 1 }]
        this.trackPixelBooks(this.company.id)
      }
      this.$axios.post(`/subscription/subscriptions/`, subscription)
        .then(() => {
          this.$store.commit('subscriptions/update')
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    },
    trackPixel (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'StartTrial', {value: '0.00', currency: 'MYR'}, {eventID: eventID})
    },
    trackPixelBooks (eventID) {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZABOOKS_FB_PIXEL_ID, 'StartTrial', {value: '0.00', currency: 'MYR'}, {eventID: eventID})
    },
    sendEmail() {
      window.open(`mailto:support@yezza.io?subject=Switch package &body=New plan: Free / Business / Intelligence %0D%0A New Contract: Monthly / Yearly %0D%0A %0D%0A Check out Yezza's rates here: https://yezza.io/pricing?lang=eng %0D%0A %0D%0A Need more user slots or form? Enter quantity below %0D%0A Whatsapp Form (RM3/form/month) : %0D%0A Sales Team (RM10/person/month)  : %0D%0A %0D%0A Company Name: ${this.company.name} %0D%0A %0D%0A Regards, %0D%0A ${this.member.user.first_name + ' ' + this.member.user.last_name}`, '_blank')
    },
    sendRequest() {
      this.openTypeFormDialog = true
    },
    startUnsubscribe () {
      this.isLoading = true
      this.$axios.post(`/subscription/subscriptions/${this.unsubscribePlan.id}/cancel/`, {})
        .then(() => {
          this.message = `Unsubscribe ${this.unsubscribePlan.title} successful`
          this.openSuccessDialog = true
        })
        .catch(() => {
          this.showMessage(['error', 'Unable to upgrade. Please contact our support team.'])
          this.isLoading = false
        })
    },
    unsubscribeCurrentPlan (plan) {
      let title = ''
      if (plan.data.plan_group === 'LANDING_PAGE') {
        title = 'Sales page'
      } else if (plan.data.plan_group === 'FOLLOW_UP') {
        title = 'Follow-up'
      } else if (plan.data.plan_group === 'PRODUCT_BUNDLE') {
        title = 'Bundle offers'
      } else if (plan.data.plan_group === 'RESELLER') {
        title = 'Agent commission'
      } else if (plan.data.plan_group === 'YCONNECT') {
        title = 'Connect Basic'
      }
      this.unsubscribePlan = {
        ...plan.data,
        title
      }
      this.unsubscribeModal = true
    },
    closeDialog () {
      this.openSuccessDialog = false
      this.unsubscribeModal = false
      this.unsubscribePlan = null
      this.message = null
      window.location.reload()
    },
    checkCode (code) {
      if (code === 'YZ_LANDING_PAGE') {
        return true
      } else if (code === 'YZ_FOLLOW_UP') {
        return true
      } else if (code === 'YZ_PRODUCT_BUNDLE') {
        return true
      } else if (code === 'YZ_RESELLER') {
        return true
      }
      return false
    },
    setGene () {
      this.$axios.get(`/companies/${this.company.id}/genes`)
        .then((response) => {
          this.$store.commit('subscriptions/setGenes', response.data)
        })
    },
    checkExpired (subscription) {
      this.isLoadingExpired = true
      this.$axios.get(`/subscription/bills/?page=1&page_size=12&company=${this.company.id}&ordering=-created&paid=false`)
        .then((response) => {
          let bills = response.data.results
          let hasPendingBills = response.data.count > 0
          this.$store.commit('subscriptions/setHasPendingBills', hasPendingBills)
          if (hasPendingBills) {
            this.$router.push(`/admin/billing/bills/${bills[0].id}`)
          } else {
            if (subscription === 'yezza') {
              this.showSubscribeModal = true
            }
            else if (subscription === 'books') {
              this.showSubscribeBookModal = true
            }
            else if (subscription === 'clinic') {
              this.showSubscribeClinicModal = true
            }
            else if (subscription === 'review') {
              this.showSubscribeReviewModal = true
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoadingExpired = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "subscription": "Subscription",
    "my_plans": "My plans",
    "products_plans_subscribed": "Products and plans you are subscribed to.",
    "click_here": "Click here",
    "to_change_company_subscription": "to change your company subscription.",
    "no_subscription_found": "No subscription found",
    "trial_ended_at": "Trial ended at",
    "trial_ends": "Trial ends",
    "next_billing_date": "Next billing date",
    "contract_ends": "Contract ends",
    "sales_team": "Sales Team",
    "unlimited": "Unlimited",
    "whatsapp_forms": "WhatsApp Forms",
    "sales_page": "Sales Page",
    "trial": "TRIAL",
    "books": "Books",
    "reminder_scheduling": "Reminder Scheduling",
    "more_products": "More products",
    "more_products_desc": "Check out other products that we offer.",
    "on_trial": "On Trial",
    "subscribed": "Subscribed",
    "tell_me_more": "Tell me more",
    "setup_online_store_manage": "Setup an online store and manage orders all in one place",
    "subscribe": "Subscribe",
    "keep_track_income_expenses": "Keep track of your income and expenses with Books",
    "unsubscribe": "Unsubscribe",
    "monthly": "Monthly",
    "bundle_offer": "Bundle offer",
    "agent_commission": "Agent commission",
    "custom_your_landing_page": "Custom your landing page with headline, copywriting & images",
    "check_out_addons": "Check out add-ons that we offer.",
    "increase_your_sales_through": "Increase your sales through an automated follow-up routine",
    "included": "Included",
    "active_until": "Active until",
    "increase_average_sales_bundle": "Increase average sales per order through bundle offers to your customers.",
    "increase_sales_multi_level": "Increase your sales using multi-level agent commissions system.",
    "yezza_price_per_month": "from {price}/month",
    "books_price_per_month": "from {price}/month",
    "page_price_per_month": "from {price}/month",
    "follow_up_price_per_month": "from {price}/month",
    "bundle_price_per_month": "from {price}/month",
    "agent_price_per_month": "from {price}/month",
    "unsubscribe_confirmation": "Are you sure you want to unsubscribe",
    "connect_subscription_description": "Manage workflow and 1:1 engagements on WhatsApp.",
    "clinic": "Clinic",
    "review_subscription_description": "Manage your review from your customer",
    "review_subscription_setup": "Setup your review management system in 2 minutes"
  },
  "id": {
    "subscription": "Langganan",
    "my_plans": "Rencanaku",
    "products_plans_subscribed": "Produk dan paket langganan kamu.",
    "click_here": "Klik disini",
    "to_change_company_subscription": "untuk mengubah langganan perusahaan kamu.",
    "no_subscription_found": "Tidak ada langganan yang ditemukan",
    "trial_ended_at": "Uji coba berakhir pada",
    "trial_ends": "Percobaan berakhir",
    "next_billing_date": "Tanggal tagihan berikutnya",
    "contract_ends": "Kontrak berakhir",
    "sales_team": "Tim Penjualan",
    "unlimited": "Tidak terbatas",
    "whatsapp_forms": "form WhatsApp",
    "sales_page": "Halaman Penjualan",
    "trial": "UJI COBA",
    "books": "Buku",
    "reminder_scheduling": "Penjadwalan Pengingat",
    "more_products": "Produk lainnya",
    "more_products_desc": "Lihat produk lain yang kami tawarkan.",
    "on_trial": "Sedang Percobaan",
    "subscribed": "Berlangganan",
    "tell_me_more": "Ceritakan lebih banyak lagi",
    "setup_online_store_manage": "Siapkan toko online dan kelola semua pesanan dalam satu tempat",
    "subscribe": "Langganan",
    "keep_track_income_expenses": "Pantau pemasukan dan pengeluaran kamu dengan Book",
    "unsubscribe": "Berhenti berlangganan",
    "monthly": "Bulanan",
    "bundle_offer": "Penawaran paket",
    "agent_commission": "Komisi agen",
    "custom_your_landing_page": "Kustomisasi halaman arahan kamu dengan judul, copywriting & gambar",
    "check_out_addons": "Lihat add-on yang kami tawarkan.",
    "increase_your_sales_through": "Tingkatkan penjualan kamu melalui rutinitas tindak lanjut otomatis",
    "included": "Termasuk",
    "active_until": "Aktif sampai",
    "increase_average_sales_bundle": "Tingkatkan rata-rata penjualan per pesanan melalui penawaran Bundle kepada pelanggan kamu.",
    "increase_sales_multi_level": "Tingkatkan penjualan kamu menggunakan sistem komisi agen multi-level.",
    "yezza_price_per_month": "dari {price}/bulan",
    "books_price_per_month": "dari {price}/bulan",
    "page_price_per_month": "dari {price}/bulan",
    "follow_up_price_per_month": "dari {price}/bulan",
    "bundle_price_per_month": "dari {price}/bulan",
    "agent_price_per_month": "dari {price}/bulan",
    "unsubscribe_confirmation": "Apakah kamu yakin ingin berhenti berlangganan?",
    "connect_subscription_description": "Kelola alur kerja dan interaksi 1:1 di WhatsApp.",
    "clinic": "Clinic",
    "review_subscription_description": "Manage your review from your customer",
    "review_subscription_setup": "Setup your review management system in 2 minutes"
  }
}

</i18n>
